<template>
  <div class="live_login">
    <form>
    <div class="live_login_pass">
      <h2 class="live_login_title">忘记密码</h2>
      <div class="live_login_nav">
        <a-steps size="small" :current="changecurrent">
          <a-step title="账户确认" disabled/>
          <a-step title="密码重置" disabled/>
          <a-step title="重置完成" disabled/>
        </a-steps>
      </div>
      <div class="live_regester_input" v-if="changecurrent == 0">
        <p>
          <span>+86(中国大陆)</span>
          <input type="text" maxlength="11" @input="phonenumber=phonenumber.replace(/[^\d]/g,'')" v-model="phonenumber" placeholder="请输入您的手机号">
        </p>
        <p class="p2">
          <a-input placeholder="图片验证码" v-model:value="verify"/>
          <span class="p2_right">
            <img :src="urlcodeimg" alt="loading">
            <span @click="imgVerification">
              <i>看不清？</i>
            </span>
          </span>
        </p>
        <p class="p3">
          <input type="text" v-model="verificationcode" name="code" placeholder="请输入验证码" @input="verificationcode=verificationcode.replace(/[^\d]/g,'')">
          <a-button @click="handlersendcode()" :disabled="isCountDown" :class="{mask:isCountDown}">{{isCountDown ? Count : "发送验证码" }}</a-button>
        </p>
        <div @click="handlernext1">
          <a-button type="primary" style="width:100%" :disabled="isboolablednext">
            下一步
          </a-button>
        </div>
      </div>
      <div class="live_regester_input" v-if="changecurrent == 1">
        <p :style='{margin:isSafepass?"0 0 0px":"0 0 28px"}'>
          <input class="live_regester_pass" type="password" autocomplete  v-model='password1' name="pass1" placeholder="设置您的密码" style="width:100%;height:100%">
        </p>
        <div class="cyl" v-if="isSafepass">
          <ExclamationCircleOutlined />&emsp;
          <span style="font-size: 6px;color:#b33a3b;">密码不少于6位,包括字母、数字、字符</span>
        </div>
        <p :style='{margin:isSamepass?"0 0 0px":"0 0 28px"}'>
          <input class="live_regester_pass" type="password" autocomplete v-model='password2' name="pass2" placeholder="确认密码" style="width:100%;height:100%">
        </p>
        <div class="cyl" v-if="isSamepass">
          <ExclamationCircleOutlined />&emsp;
          <span style="font-size: 6px;color:#b33a3b;">两次输入的密码不一致</span>
        </div>

        <div class="live_login_regester" @click="handlernext2">
          <a-button type="primary" style="width:100%;" :disabled="isboolabled">
            下一步
          </a-button>
        </div>
      </div>
      <div class="live_regester_input" v-if="changecurrent == 2">
        <span class="span1">
          密码重置完成，正在返回登录页面!
          <SyncOutlined spin />
        </span>
      </div>
      <div style="text-align: right;user-select: none;">
        <span @click="handlerbacklogin" style="cursor: pointer;">返回登录</span>
      </div>
    </div>
    </form>
  </div>
</template>
<script>
import {ExclamationCircleOutlined,SyncOutlined} from '@ant-design/icons-vue';
import {getImageCode,forgotPassWord,isPhoneExist,sendSMSCode,forgotPassWordReset} from '@/api/api'
import {methodCallback} from '@/api/methodCallback'
import {notification} from 'ant-design-vue';
export default {
  components: {
    ExclamationCircleOutlined,
    SyncOutlined
  },
  data() {
    return {
      changecurrent: 0, //操作步骤
      password1: "",
      password2: "",
      value: "",
      phonenumber: "", // 手机号
      verificationcode: "", //手机验证码
      verify: '', // 图片验证码
      codeid: "", // 验证码图片id
      urlcodeimg: "", // 验证码图片地址
      isCountDown: false, // 触发倒计时
      Count: "(60s)",
      phone: "", // 手机号
      number: 60, // 短信验证倒计时
      nickname: "", // 昵称
      code: "", // 验证码
      isSafepass: false, // 对密码的验证
      isSamepass: false, // 密码不一致提示
      itemer: null, // 节流
      forgotPasswordUid: "", //忘记密码唯一标识
      isboolabled: true, // 第二部
      isboolablednext: true // 第一部
    }
  },
  watch: {
    phonenumber(newvale) {
      this.phone = newvale
    },
    password1(newval) {
      if (newval !== this.password2) {
        console.log("密码变更")
        this.isboolabled = true
        this.isSamepass = true
      } else {
        this.isboolabled = false
        this.isSamepass = false
      }
      if (/^(?=.*([a-zA-Z].*))(?=.*[0-9].*)[a-zA-Z0-9-*/+.~!@#$%^&*()]{6,20}$/.test(newval)) {
        this.isSafepass = false
      } else {
        this.isSafepass = true
      }
    },
    password2: {
      handler(newval) {
        this.itemer = setTimeout(() => {
          this.itemer = null
          if (newval == this.password1) {
            this.isSamepass = false
            this.isboolabled = this.isSamepass
          } else {
            this.isSamepass = true
            this.isboolabled = this.isSamepass
          }
        }, 1000)
      },
      deep: true
    }
  },
  mounted() {
    this.imgVerification()
    // //防止页面后退
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    });
  },
  methods: {
    //图片验证码
    imgVerification(){
    	let data = {
    		width: 80,
    		height: 30,
    		codeType: 1
    	}
    	getImageCode(data)
    		.then((res) => {
    			this.urlcodeimg = res.data.data.code
    			this.codeid = res.data.data.uid
    		})
    		.catch((err) => {
    			console.log(err)
    		});
    },
    // 发送验证码是否正确或为空
    handlersendcode() {
      if (this.phonenumber == "") {
        notification.warning({
          message: '警告！',
          description: "手机号不能为空",
          duration: 2,
          key: "14",
          top: '20px',
        });
        return
      }
      if (this.verify == "") {
        notification.warning({
          message: '警告！',
          description: "图片验证码不能为空",
          duration: 2,
          key: "15",
          top: '20px',
        });
        return
      }
      //验证手机号是否注册过
    	let data = {
        phone: this.phonenumber
    	}
    	isPhoneExist(data)
    		.then((res) => {
          if(res.data.code == "NOT_FOUND_DATA"){
            notification.warning({
              message: '警告！',
              description: "用户名未注册,请先注册",
              duration: 2,
              key: "16",
              top: '20px',
            });
          }else if(res.data.code == "PHONE_EXIST"){
    				this.sendInformation();
    			}else{
            methodCallback(res);
          }
    		})
    		.catch((err) => {
    			console.log(err)
    		});
    },
    //发送短信接口
    sendInformation(){
      let data = {
        phone: this.phonenumber,
        codeType: 1
      }
    	sendSMSCode(data)
    		.then((res) => {
    			if(res.data.code == "SUCCESS"){
    				this.countdown();
            this.isboolablednext = false
    			}else{
            methodCallback(res);
          }
    		})
    		.catch((err) => {
    			console.log(err)
    		});
    },
    //60秒倒计时
    countdown() {
      this.isCountDown = true
      let num = this.number
      let ids = setInterval(() => {
        num -= 1
        this.Count = `(${num}s)`
        if (num <= 0) {
          this.isCountDown = false
          clearInterval(ids)
        }
      }, 1000);
    },
    //步骤条一的操作
    handlernext1() {
    	if (this.verificationcode == "") {
    		notification.warning({
    			message: '警告！',
    			description: "手机短信验证码不能为空",
    			duration: 2,
    			key: "17",
    			top: '20px',
    		});
    		return
    	}
    	//忘记密码
      let data = {
        phone: this.phonenumber,
    	  phoneCode: this.verificationcode,
    	  imageUid: this.codeid,
        imageCode: this.verify,
      }
    	forgotPassWord(data)
        .then(res => {
          if(res.data.code === "SUCCESS"){
            console.log(res.data.data.forgotPasswordUid)
            this.forgotPasswordUid = res.data.data.forgotPasswordUid;
            this.changecurrent = 1;
          }else{
            methodCallback(res);
          }
        }).catch(err => {
          console.log(err)
        })
    },
    //步骤条二的操作
    handlernext2() {
    	if (this.isSamepass) {
    		notification.warning({
    			message: '警告！',
    			description: "两次输入密码不一致,请重新输入",
    			duration: 2,
    			key: "18",
    			top: '20px',
    		});
    		return
    	}
      let data = {
    	  forgotPasswordUid: this.forgotPasswordUid,
    	  password: this.password1,
      }
    	forgotPassWordReset(data)
        .then(res => {
          if (res.data.code === "SUCCESS") {
            this.changecurrent = 2;
            let ids = setTimeout(() => {
              this.handlerbacklogin()
              clearTimeout(ids)
            }, 3000);
          }else{
            methodCallback(res);
          }
        }).catch(err => {
          console.log(err)
        })
    },
    //返回登录
    handlerbacklogin() {
      localStorage.removeItem("token")
      this.$router.replace({ name: "login" })
      this.changecurrent = 0;
    },
  }
}
</script>
<style lang="less">
.live_login {
  height: 100%;
  background-size: 100% 100%;
  background: url("../../assets/images/002.png");
  &_pass {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -250px;
    margin-top: -250px;
    border: 1px solid black;
    width: 500px;
    height: 500px;
    background: white;
    box-sizing: border-box;
    padding: 52px 70px 0 70px;
  }
  &_title {
    margin-bottom: 53px;
    width: 100%;
    height: 30px;
		line-height: 30px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #4c4c4c;
    text-align: center;
  }
}
/* 注册样式 */
.live_regester_input {
  margin-top: 47px;
  margin-bottom: 50px;
  .cyl{
    width: 100%;
    height: 28px;
    display: flex;
    align-items: center;
  }
	.p2{
		border: none;
		display: flex;
		justify-content: space-between;
		input{
			width: 150px;
			border: 1px solid #7B7B7B;
		}
		.p2_right{
			border: 1px solid #7B7B7B;
			display: inline-block;
			width: 170px;
			height: 32px;
			border-radius: 4px;
			margin: 0;
      img{
        width: 80px;
        height: 30px;
        margin-left: 5px;
      }
      span{
        cursor: pointer;
        user-select: none;
        margin: 0;
        margin-left: 12px;
        i{
          font-size: 12px;
          font-style: italic;
          margin: 0;
        }
      }
		}
	}
  .p3{
    border: none;
    display: flex;
    justify-content: space-between;
    input{
      border: 1px solid #7B7B7B;
      border-radius: 2px;
      height: 36px;
      width: 200px;
      padding-left: 40px;
    }
    button{
      width: 150px;
      height: 36px;
      background: #D6E6FF;
      outline: none;
      border: none;
      border: 1px solid #1877F2;
      cursor: pointer;
      span{
        color: #1877F2;
      }
    }
  }
  .span1{
    width: 255px;
    height: 16px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-left: 50px;
    margin-top: 100px;
    text-align: center;
    display: block;
    color: #1877F2;
  }
  p {
    margin-bottom: 20px;
    width: 356px;
    height: 34px;
    border-radius: 2px;
    border: 1px solid #7b7b7b;
    display: flex;
    align-items: center;
    border-radius: 2px;
    span {
      color: #525252;
      font-size: 14px;
      margin-left: 12px;
      margin-right: 12px;
    }
    input {
      border: none;
    }
    .live_regester_pass {
      margin-left: 13px;
      font-size: 14px;
      color: #c0c1c2;
    }
    .mask {
      width: 150px;
      height: 36px;
      background: rgba(0, 0, 0, 0.4) !important;
      border: none !important;
    }
  }
}
.live_login_nav {
  position: relative;
  left: 17px;
}
.ant-steps-small .ant-steps-item-icon {
  display: none !important;
}
.ant-steps-item-title::after {
  content: ". . . . ." !important;
  font-size: 20px !important;
}
.ant-steps-small .ant-steps-item-title::after {
  top: -6px !important;
}
.ant-steps-item-container {
  width: 100px;
}
</style>
